import React, { Component } from 'react';
import Style from './Button.css';

class Button extends Component {
	render() {
		return (
			<a style={Style.button} role="button" target="_blank" rel="noopener" id={this.props.buttonId} className="button" href={this.props.buttonLink}>
				{this.props.buttonTitle}
			</a>
		);
	}
}

export default Button;
